import { HTMLFromRichText } from './PrismicTypes';

export const GENERIC_RICH_TEXT = 'PrismicGenericTemplateDataBodyRichText';

export interface GenericRichTextPrimary {
  is_full_width?: boolean;
  rich_text_content: HTMLFromRichText;
  text_alignment?: 'left' | 'center' | 'right' | 'justify';
}

export interface GenericRichTextContent {
  __typename: typeof GENERIC_RICH_TEXT;
  primary: GenericRichTextPrimary;
}
